import { palette } from '@shared/tokens/palette.stylex';
import { FC } from 'react';

interface LockClosedIconProps {
  color?: string;
  size?: string;
}

export const LockClosedIcon: FC<LockClosedIconProps> = ({ color = palette['grey-700'], size = '20' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6.5C6.5 4.567 8.067 3 10 3C11.933 3 13.5 4.567 13.5 6.5V8.5C14.6046 8.5 15.5 9.39543 15.5 10.5V15C15.5 16.1046 14.6046 17 13.5 17H6.5C5.39543 17 4.5 16.1046 4.5 15V10.5C4.5 9.39543 5.39543 8.5 6.5 8.5V6.5ZM6.5 9.5C5.94772 9.5 5.5 9.94772 5.5 10.5V15C5.5 15.5523 5.94772 16 6.5 16H13.5C14.0523 16 14.5 15.5523 14.5 15V10.5C14.5 9.94772 14.0523 9.5 13.5 9.5H6.5ZM12.5 8.5H7.5V6.5C7.5 5.11929 8.61929 4 10 4C11.3807 4 12.5 5.11929 12.5 6.5V8.5Z"
        fill={color}
      />
    </svg>
  );
};
